<template>
    <div>
        <inspiration-view :content="content" />
    </div>
</template>

<script>
import InspirationView from '@/components/InspirationView';
import { fetchItem } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        InspirationView,
    },
    data() {
        return {
            content: {},
        };
    },
    computed: {},
    watch: {},
    mounted() {
        this.fetchInspiration();
    },
    methods: {
        async fetchInspiration() {
            const inspiration = await fetchItem(
                'inspiration',
                this.$route.params.inspirationId
            );
            this.content = inspiration.data;
            console.log(inspiration.data);
        },
    },
};
</script>

<style scoped lang="css">
@import '~splitpanes/dist/splitpanes.css';
html {
    overflow: auto;
}
.splitpanes__pane {
    background-color: transparent !important;
}
</style>
